'use client'
import { Button } from '@/ui/button'
import { CardContent, CardFooter } from '@/ui/card'
import { Form, FormField } from '@/ui/form'
import { useRouter } from 'next/navigation'
import { FormFloatingLabelInput, FormFloatingPasswordLabelInput } from '@/shared/ui/input/form-floating-label-input'
import { paths } from '@/shared/routing'
import { buildUrlWithUtm } from '@/shared/lib/url-params'
import { fieldNames } from '@/shared/constants/field-names'
import { LoginDto, LoginFormReturn, loginSelectors, useLoginStore } from '../model'
interface LoginFormProps extends LoginFormReturn {
  onSubmit: (v: LoginDto) => void
}
export default function LoginForm({ onSubmit, ...form }: LoginFormProps) {
  const loading = useLoginStore(loginSelectors.selectLoading)
  const router = useRouter()

  const handleRestorePassword = () => router.push(buildUrlWithUtm(paths.restorePassword))

  return (
    <>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-col gap-4">
          <CardContent className="px-0 flex flex-col gap-2 pt-0 pb-2">
            <div className="grid gap-2">
              <FormField
                control={form.control}
                name={fieldNames.EMAIL}
                render={(props) => <FormFloatingLabelInput label="Почта *" {...props} />}
              />
            </div>
            <div className="grid gap-2">
              <FormField
                control={form.control}
                name={fieldNames.PASSWORD}
                render={(props) => <FormFloatingPasswordLabelInput label="Пароль *" {...props} />}
              />
            </div>
          </CardContent>
          <CardFooter className="p-0 flex flex-col gap-2">
            <Button type="submit" className="w-full" loading={loading === 'loading'} size="lg">
              Войти через почту
            </Button>
            <Button
              type="button"
              variant="ghost"
              className="w-full text-muted-foreground"
              size="lg"
              onClick={handleRestorePassword}
            >
              Забыли пароль?
            </Button>
          </CardFooter>
        </form>
      </Form>
    </>
  )
}
